<template>
  <el-dialog
    v-if="dialogVisible"
    class="subscribe-cross-chain-node-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="35vh"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :label-position="position"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="跨链服务IP地址" prop="serverIP">
        <el-input v-model="dataForm.serverIP"></el-input>
      </el-form-item>

      <el-form-item label="IP端口" prop="serverPort">
        <el-input v-model="dataForm.serverPort"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleSubscribeCross()">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'SubscribeCrossNode',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 120
  },
  data() {
    return {
      isDownView: false,
      disabled: false,
      dialogVisible: false,
      title: '订阅',
      position: 'right',
      dataForm: {
        serverIP: '',
        serverPort: null,
        crosschainId: null
      },
      editRule: {
        serverIP: [{ required: false, message: '请输入', trigger: 'blur' }],
        serverPort: [
          { required: false, message: '请输入', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur' }
        ]
      },
      adaptationVars: {
        formLabelWidth: 120
      }
    }
  },
  mounted() {},
  methods: {
    //订阅跨链节点
    handleSubscribeCross() {
      let params = this.dataForm
      if (this.dataForm.serverPort) {
        params.serverPort = Number(this.dataForm.serverPort)
      } else {
        params.serverPort = 0
      }
      this.$apis.crossChain
        .subscribeCrossChain(params)
        .then(res => {
          if (res) {
            this.handleCancel()
            this.$message.success('订阅成功')
            this.getList()
          }
        })
        .catch(err => {
          this.disabled = false
        })
    },

    handleCancel() {
      this.dialogVisible = false
      this.disabled = false
    },
    handleOpen(data) {
      this.dataForm = {
        serverIP: '',
        serverPort: null,
        crossChainId: ''
      }
      this.dataForm.crossChainId = data.id
      this.dialogVisible = true
      this.isDownView = false
    }
  }
}
</script>

<style scoped lang="scss">
.subscribe-cross-chain-node-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
